<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light m-0">
    <!-- Alert message -->
    <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <!-- Title-->
    <header-component :headerTitle="headerText" />

    <!-- Update popup -->
    <v-row justify="center">
      <v-dialog v-model="UpdatePopup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Update Markdown Location</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="updatePendingConfirmationCancel">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-form>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="5" md="6">
                    <v-text-field color="primary" variant="outlined" :disabled="true" label="ASP (₹)" v-model="formattedAspSum"> </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="5" md="6" v-if="!$isRelianceClient()">
                    <v-autocomplete v-if="isPendingPriceTab"
                      v-on:keyup.enter="loadData(active_tab)" color="primary" v-model="location_id" variant="outlined" :items="locationList"
                      item-title="code" item-value="code" label="Location ID">
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="5" md="6" v-if="$isRelianceClient()">
                    <v-autocomplete v-if="isPendingPriceTab"
                      v-model="location_id_rel" variant="outlined" :items="locationListRel"
                      item-title="name" item-value="id" label="Location ID" @change="changeLocation(location_id_rel)">
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row v-if="more_id === 'more'">
                    <v-col cols="12" sm="4" md="6" style="height: 96px;">
                      <span></span>
                    </v-col>
                    <v-col cols="12" sm="4" md="6" style="height: 96px;">
                      <v-text-field  hide-details label="Enter Name" variant="outlined" v-model="enter_name" oninput="this.value = this.value != ' ' ? this.value.replace(/[^a-zA-Z ]/g, '').replace(/\s+/g, ' ') : ''"></v-text-field>
                    </v-col>
                  </v-row>
                <v-row>
                  <v-col cols="12" sm="5" md="6">
                    <v-text-field v-on:keyup="makeMarkdownDiscountDisable()" color="primary" variant="outlined" :disabled="markdown_pr_dis"
                      label="Markdown Discount Value (₹)" v-model="formattedMarkdownDiscount" :rules="[inputRules]">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="5" md="6">
                    <v-text-field v-on:keyup="makeMarkdownPriceDisable()" color="primary" variant="outlined" :rules="[inputRules]"
                      :disabled="markdown_discount_dis" label="Markdown Discount (%)" v-model="markdown_discount">
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-form>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="flat" color="white" class="mb-3 bg-blue text-none" v-if="!$isRelianceClient()"  :disabled="number > 0" @click="updatePendingConfirmationSubmit">Submit</v-btn>
            <v-btn variant="flat" color="primary" v-if="$isRelianceClient()" class="mb-3 text-none" :disabled="number > 0" @click="updateSupplierApi">Submit</v-btn>
            <v-btn variant="outlined" color="primary" class="cancel-color mb-3 text-none" @click="updatePendingConfirmationCancel">Cancel</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- filter data popup -->
    <v-row justify="center">
      <v-dialog content-class="filter-data" v-model="filterPopup" persistent max-width="1224px">
        <v-card class="filter_ui">
          <v-card-actions>
            <v-row>
              <v-col class="p-0 pt-2">
                <v-text-field v-if="isPendingPriceTab" color="primary" v-model="tag_id_search" label="Tag Id" class="ma-2" variant="outlined" v-on:keyup.enter="loadData(active_tab)">
                </v-text-field>
              </v-col>
              <v-col class="p-0 pt-2">
                <v-menu 
                  v-model="aspValue" 
                  :close-on-content-click="false" 
                  transition="scale-transition" 
                  offset-y
                  max-width="290"
                >
                  <template v-slot:activator="{ props }">
                    <v-combobox 
                      v-model="random" 
                      v-bind="props" 
                      color="primary" 
                      variant="outlined" 
                      label="ASP (₹)" 
                      :items="asplist" 
                      class="ma-2"
                    >
                    </v-combobox>
                  </template>
                  <v-card style="margin-top: -20px !important;">
                    <v-card-title class="d-flex align-center">
                      <span>ASP (₹)</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                      <div class="d-flex mb-2">
                        <div class="w-25">
                          <div class="d-flex align-items-center h-100 justify-center">Min</div>
                        </div>
                        <div class="w-75 px-2">
                          <v-text-field 
                            variant="outlined" 
                            hide-details 
                            type="number" 
                            label="Enter Price" 
                            v-model="minValue" 
                            class="ma-0"
                          ></v-text-field>
                        </div>
                      </div>
                      <div class="d-flex mb-2">
                        <div class="w-25">
                          <div class="d-flex align-items-center h-100 justify-center">Max</div>
                        </div>
                        <div class="w-75 px-2">
                          <v-text-field 
                            variant="outlined" 
                            hide-details 
                            type="number" 
                            label="Enter Price" 
                            v-model="maxValue" 
                            class="ma-0"
                          ></v-text-field>
                        </div>
                      </div>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions class="justify-center">
                      <v-btn 
                        size="small" 
                        variant="outlined" 
                        class="text-none" 
                        @click="cancelAspValues"
                      >
                        Cancel
                      </v-btn>
                      <v-btn 
                        size="small" 
                        variant="flat" 
                        color="primary" 
                        class="text-none" 
                        @click="aspValue = !aspValue"
                      >
                        Submit
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </v-col>
              <v-col class="p-0 pt-2">
                <v-autocomplete v-if="isPendingPriceTab" color="primary" style="max-width: 290px !important;"
                  v-on:keyup.enter="loadData(active_tab)" v-model="category_filter" variant="outlined" :items="categoryList"
                  item-title="name" item-value="id" label="Category" class="ma-2" multiple ref="categorySearchClear">
                </v-autocomplete>
              </v-col>
              <v-col class="p-0 pt-2">
                <v-autocomplete v-if="isPendingPriceTab" color="primary" style="max-width: 290px !important;"
                  v-on:keyup.enter="loadData(active_tab)" v-model="grade_filter" variant="outlined" :items="gradeList"
                  item-title="gradeList" item-value="gradeList" label="Grade" class="ma-2" multiple ref="gradeSearchClear">
                </v-autocomplete>
              </v-col>
              <v-col class="p-0 pt-2">
                <v-autocomplete  color="primary" style="max-width: 290px !important;"
                  v-model="putaway_filter" variant="outlined" :items="puttawayList"
                   label="Putaway Status" class="ma-2">
                </v-autocomplete>
              </v-col>
            </v-row>
            
          </v-card-actions>
          <v-card-actions class="margin-10">
            <v-spacer></v-spacer>
            <v-btn class="text-none" size="small" variant="outlined" color="normal" @click="closeFilterpopup">Cancel</v-btn>
            <v-btn class="text-none" size="small" variant="flat" color="primary" @click="applyFilterFunc">Apply Filter(s)</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Table-data Detail Popup for Pending Price & Location -->
    <v-row justify="center">
      <v-dialog v-model="dataDetailPendingPricePopup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Tag ID: {{ tag_number }}</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="dataDetailPendingPricePopup = !dataDetailPendingPricePopup">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-card-text>
            <v-container>
              <div>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Article id</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.article_id ? item_details.article_id : 'N/A' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Article Description</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.article_description ? item_details.article_description : 'N/A' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">ASP (₹)</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.price && item_details.price != "NA" ? (item_details.price).toLocaleString('en-IN') : 0  }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Category</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.category ? item_details.category : 'N/A' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Grade</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.grade ? item_details.grade : 'N/A' }}
                  </v-col>
                </v-row>
                <v-row v-if="active_tab === 'Pending ORRD'">
                  <v-col cols="6">
                    <span style="font-weight: 500;">ORRD Request ID</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.orrd_request_id ? item_details.orrd_request_id : 'N/A' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Markdown Location</span>
                  </v-col>
                  <v-col cols="6">
                    <a @click="updateSecondDialog" style="color: #1976d2;"  class="update_disabled">update
                    </a>
                  </v-col>
                </v-row>
              </div>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Table-data Detail Popup for Dispatch -->
    <v-row justify="center">
      <v-dialog v-model="dataDetailDispatchPopup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Tag ID: {{ tag_number }}</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="dataDetailDispatchPopup = !dataDetailDispatchPopup">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-card-text>
            <v-container>
              <div>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Article id</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.article_id ? item_details.article_id : 'N/A' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Article Description</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.article_description ? item_details.article_description : 'N/A' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">ASP (₹)</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.price  && item_details.price != "NA" ? (item_details.price).toLocaleString('en-IN') : 'NA' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Category</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.category ? item_details.category : 'N/A' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Grade</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.grade ? item_details.grade : 'N/A' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Markdown Location</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.markdown_location ? item_details.markdown_location : 'N/A' }}
                  </v-col>
                </v-row>
              </div>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <!--Approve Ok confirm popup -->
    <v-row justify="center">
      <v-dialog v-model="okapproveconfirmpopup" persistent max-width="424px">
        <v-card class="v-card-100 pa-2">
          <v-card-title>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text class="text-center">
            <span> {{ message }} </span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="flat" color="primary" class="mb-3 text-none" @click="afterClickOkLoadData">Ok</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Header -->
    <v-card class="v-card-100">
      <v-tabs color="primary" v-model="selected_tab">
        <v-tab ripple @click="loadData(tab, 'tab_clicked')"
          style="text-transform:none!important;text-decoration: none;" v-for="(tab, index) in tabs" class="tab-color"
          :key="index">{{ tab }}</v-tab>
      </v-tabs>
    </v-card>

    <!-- search, filter, Action buttons -->
    <v-card-title style="padding-left: 28px; padding-bottom: 0px;" class="action-style">
    <v-row class="me-3 my-2">
      <!-- Search fields -->
      <v-row>
          <v-combobox class="text-left ma-4" v-model="select_field" item-title="name" item-value="id" :items="select_field_items" label="Select Field" variant="outlined" style="max-width: 158px; max-height: 52px;"> </v-combobox>
          <v-text-field class="m-3" prepend-inner-icon="mdi-magnify" :disabled="!select_field" color="primary" v-model="search_tag" v-no-edge-space label="Search" style="max-width: 300px; max-height: 52px;" variant="outlined" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
      </v-row>
      <!-- Actions buttons -->
      <v-actions style="margin-bottom: 17px; margin-top:4px">
        <!-- <v-btn class="mr-2 text-none" size="x-large" disabled variant="flat" v-if="active_tab == 'Pending Price & Location' && (isActionAllowed(role) || role == 'warehouse_manager')" color="primary" @click="updatedialog" style="min-height: 52px;">Update</v-btn> -->
        <v-btn class="mr-2 text-none" size="x-large" variant="flat" v-if="($isRelianceClient() || $isWhirlpoolClient()) && (isActionAllowed(role) && isPendingPriceTab)" :disabled="!table_data || table_data.length === 0" @click="downloadSelected()" color="primary" style="min-height: 52px;">Download</v-btn>
        <v-btn class="mr-2 text-none" size="x-large" variant="flat" v-if="isPendingPriceTab && ($isRelianceClient() || $isWhirlpoolClient()) && isActionAllowed(role)"  :disabled="(selected.length != 0)" @click="navigateToFileUpload" color="primary" style="min-height: 52px;">Upload</v-btn>
      </v-actions>

      <!-- Filter -->
      <v-expansion-panels v-if="isPendingPriceTab" class="custom-control_outlined mt-1"
        ref="filterPopupRef" readonly style="max-width: 300px; margin-bottom: 15px; min-height: 52px;">
        <v-expansion-panel variant="outlined" @click="filterListOfButtons" style="height: 52px;">
          <v-expansion-panel-title>Filter
          </v-expansion-panel-title>
        </v-expansion-panel>
      </v-expansion-panels>
      </v-row>
    </v-card-title>

    <!-- Data Table -->
    <v-layout column>
      <v-col cols="12" style="overflow: auto" class="p-0">
        <v-data-table hover 
          density="compact"
          :search="search"
          v-model="selected"
          show-select
          disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :items="table_data"
          :loading="loading"
          fixed-header
          height="100%"
          :items-per-page="pageSize"
          loading-text="Loading Data... Please wait" class="elevation-1"
          return-object
          >
          <template #[`header.disposition_age`]="{ column }">
            <span>{{ column.title }}
              <AgeingTooltip />
            </span>
          </template>
          <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers" :key="header.key">
              <span v-if="header.key == 'tag_id'">
                <a href="#" @click.prevent="itemDetailpopup(item)" style="text-decoration: underline !important; color: #1976d2 !important; cursor: pointer !important;">{{ item.tag_id }}</a>
              </span>
              <span v-else-if="header.key == 'asp'">
                <span>{{ item.asp && item.asp != "NA" ? (item.asp).toLocaleString('en-IN') : 'NA' }}</span>
              </span>
              <span v-else-if="header.key == 'markdown_price'">
                <span>{{ item.markdown_price && item.markdown_price != "NA" ? (item.markdown_price).toLocaleString('en-IN') : 'NA' }}</span>
              </span>

              <span v-else-if="header.key !== 'images' && item[header.key]">
                <span v-tooltip="item[header.key]">
                  {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                </span>
              </span>
              <span v-else>-</span>
            </template>
          <!-- <template #[`item.tag_id`]="{ item }">
            <a @click="itemDetailpopup(item)" style="color: #1976d2;" class="cursor-pointer">
              <u> {{ item.tag_id }}</u>
            </a>
          </template> -->
          <!-- <template #[`item.challan`]="{ item }">
            <span>{{ item.challan ? item.challan : "-" }}</span>
          </template> -->
          <!-- <template #[`item.price`]="{ item }">
            <span>{{ item.price && item.price != "NA" ? (item.price).toLocaleString('en-IN') : 'NA' }}</span>
          </template>
          <template #[`item.asp`]="{ item }">
            <span>{{ item.asp && item.asp != "NA" ? (item.asp).toLocaleString('en-IN') : 'NA' }}</span>
          </template> -->
          <!-- <template #[`item.supplier_code`]="{ item }">
            <span>{{ item.supplier_code ? item.supplier_code : "-" }}</span>
          </template> -->
          <!-- <template #[`item.markdown_price`]="{ item }">
            <span>{{ item.markdown_price && item.markdown_price != "NA" ? (item.markdown_price).toLocaleString('en-IN') : 'NA' }}</span>
          </template> -->
          <template #bottom></template>
        </v-data-table>
      </v-col>
    </v-layout>

    <!-- pagination display -->
    <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-2 mb-0"
                />
    <!-- Download Popup Component -->
    <DownloadPopup 
      ref="downloadPopup"
      v-model:visible="downloadDialog" 
      :api-endpoint="getApiEndpoint()"
      :payload="payload"
      @show-alert="handleShowAlert"
      @success="handleSuccess"
    />
  </v-card>
</template>
    
<script>
  import HeaderComponent from '../../../../commoncomponents/HeaderComponent.vue';
  import DownloadPopup from '../../../../commoncomponents/DownloadPopup.vue';
  import { moduleAccessFunc,module_that_allowed,signout,isOnlyViewAction } from '@/backend/axios/moduleAccess'
  import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
  // import { moduleAccessFunc,module_that_allowed,signout } from '@/backend/axios/moduleAccess';

  export default {
    components: {
      HeaderComponent,
      DownloadPopup
    },

    data() {
      return {
        headerText: "Markdown",
        tabs: [
          "Pending Price & Location",
          "Dispatch",
          "Pending For Approval"
        ],
        search_tag: '',
        table_data: [],
        page: 1,
        totalPages: 1,
        totalCount: '',
        pageSize: defaultPageSize,
        pageSizes: defaultPageSizes,
        active_tab: "Pending Price & Location",
        selected: [],
        search: '',
        filterPopup: false,
        tag_id_search: '',
        grade_filter: [],
        category_filter: [],
        UpdatePopup: false,
        categoryList: [],
        update_id: [],
        price: '',
        location_id: null,
        markdown_dis_value: '',
        selected_tab : 0,
        markdown_discount: '',
        okapproveconfirmpopup: false,
        message: '',
        tag_number: '',
        dataDetailPendingPricePopup: false,
        dataDetailDispatchPopup: false,
        item_details: '',
        gradeList: [],
        alert_type: 'info',
        alert_message: '',
        selectedItem: [],
        locationList: [],
        minValue: null,
        maxValue: null,
        aspPopup: false,
        markdown_pr_dis: false,
        markdown_discount_dis: false,
        selectedDirectly: false,
        aspSum: 0,
        alert: false,
        aspValue: false,
        asplist: '',
        enter_name:'',
        more_id:'',
        inputRules: [
          (v) => v == '' || v >= 0 || /^\d+(\.\d+)?$/.test(v) || "Please enter only positive numbers"
        ],
        number: 0,
        random: null,
        organization_name:'',
        location_id_rel:'',
        locationListRel:[],
        headers:[],
        isFilteringPage: false,
        downloadDialog: false,
        role:'',
        select_field_items: [
        {
          "name":"Tag ID",
          "id": "tag_number"
        },
        {
          "name":"Serial Number",
          "id": "serial_number"
        },
        {
          "name":"IRD Number",
          "id": "ird_number"
        },
        {
          "name":"IRRD Number",
          "id": "irrd_number"
        }
        ],
        select_field:null,
        putaway_filter:null,
        puttawayList:["Pending","Completed"],
        payload: {}
      }
    },

    async created() {
      this.role = this.$store.state.currentUser.roles[0]
      if(this.role in module_that_allowed && moduleAccessFunc(this.role,'MarkDown')){
        signout()
        return;
      }
      this.organization_name = this.$store.state.organization_name
      const tab = this.$store.state.active_tab
      if(tab == 'Dispatch'){
        this.selected_tab = 2
        this.loadData('Dispatch');
      } else if(tab == 'Pending ORRD'){
        this.selected_tab = 1
        this.loadData('Pending ORRD');
      } else{
        this.selected_tab = 0
        this.loadData('Pending Price & Location');
      }
      this.scrollToTop();
    },
    watch: {
      selected(newVal) {
        if (this.isPendingPriceTab) {
          const putawayInward = newVal.filter(insurances => insurances.is_putaway_inwarded === false)
          const isUnderPhysicalInspection = newVal.filter((insurances) => insurances.is_under_physical_inspection === true);
          if (putawayInward.length > 0) {
            this.showAlert("warning", "Please complete Putaway Process");
            this.selected.splice(0);
          }else if(isUnderPhysicalInspection.length > 0){
            this.$nextTick(() => {
              this.showAlert("warning", "Action on item blocked as it is under cycle count process");
              this.selected = [];
            });
          }
        }
      },
      category_filter(newValue) {
        if (newValue && newValue.length > 0) {
          this.$nextTick(() => {
            this.$refs.categorySearchClear.internalSearch = '';
          });
        }
      },
      grade_filter(newValue) {
        if (newValue && newValue.length > 0) {
          this.$nextTick(() => {
            this.$refs.gradeSearchClear.internalSearch = '';
          });
        }
      },
    },
    computed :{
      formattedAspSum(){
        return this.aspSum.toLocaleString('en-IN');
      },
      formattedMarkdownDiscount : {
        get() {
          return (this.markdown_dis_value).toLocaleString('en-IN') ;
        },
        set(value) {
          const numericValue = Number(value.replace(/[^0-9.-]+/g, ''));
          this.markdown_dis_value = Math.max(parseFloat(numericValue), '');
        },
      },
      isPendingPriceTab() {
        return this.active_tab === 'Pending Price & Location' || this.active_tab === 'Pending ORRD';
      }
    },
    methods: {
      isActionAllowed(){
        return !isOnlyViewAction(this.role, 'MarkDown')
      },
      scrollToTop() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      },
      // show Alert messages
      showAlert(alert_type, alert_message) {
        this.scrollToTop();
        this.alert = true;
        this.alert_type = alert_type;
        this.alert_message = alert_message;
        this.alertTimeOut();
      },
      alertTimeOut() {
        setTimeout(() => {
          this.alert = false;
        }, 3000);
      },

      loadData(tab, tab_action) {
        if (tab_action) {
          this.search_tag = '';
          this.select_field = null;
        }
        this.loading = true;
        this.selected = []
        this.active_tab = tab
        this.table_data = []
        this.page = 1
        this.totalPages = 1
        this.isFilteringPage= false,
        this.$store.commit('setActiveTab',{
          'active_tab' : tab
        })
        if (tab == "Pending Price & Location") {
          (this.headers = [
            { title: "Tag ID", align: "start", sortable: false, key: "tag_id" },
            { title: "Article ID", key: "article_id" },
            { title: "Article Description", key: "article_description" },
            { title: "ASP (₹)", key: "price" },
            { title: "Category", key: "category" },
            { title: "Grade", key: "grade" },
            { title: "Supplier Code", key: "supplier_code"},
            { title: "Ageing", key:"disposition_age"},
            { title: "Sub-Location", key:"sub_location_name"},
            { title: "IRRD Number", key: "irrd"},
            { title: "IRD Number", key:"ird"},
            { title: "Serial Number ", key: "serial_number" },
          ]);

          this.fetchPendingPriceAndLocation();
          this.fetchFilterCategory();
          this.fetchFilterGrade();
          this.fetchLocationId();
          if(this.$isRelianceClient()){
            this.fetchSupplierLoc();
          }else{
            this.fetchLocationId();
          }
        }
        if (tab == "Pending ORRD") {
          (this.headers = [
            { title: "Tag ID", align: "start", sortable: false, key: "tag_id" },
            { title: "Article ID", key: "article_id" },
            { title: "Article Description", key: "article_description" },
            { title: "ASP (₹)", key: "price" },
            { title: "Category", key: "category" },
            { title: "Grade", key: "grade" },
            { title: "Supplier Code", key: "supplier_code"},
            { title: "Ageing", key:"disposition_age"},
            { title: "Sub-Location", key:"sub_location_name"},
            { title: "IRRD Number", key: "irrd"},
            { title: "IRD Number", key:"ird"},
            { title: "Serial Number ", key: "serial_number" },
            { title: "ORRD Request ID", key: "orrd_request_id" },
          ]);

          this.fetchPendingOrrd();
          this.fetchFilterCategory();
          this.fetchFilterGrade();
          if(this.$isRelianceClient()){
            this.fetchSupplierLoc();  
            this.fetchLocationId();
          }else{
            this.fetchLocationId();
          }
        }
        if (tab == "Dispatch") {
          (this.headers = [
            { title: "Tag ID", align: "start", sortable: false, key: "tag_id" },
            { title: "ASP (₹)", key: "asp" },
            { title: "Markdown Price (₹)", key: "markdown_price" },
            { title: "Markdown Location", key: "markdown_location" },
            { title: "Transfer Order No", key: "transfer_order_no" },
            { title: "Challan", key: "challan" },
            { title: "Ageing", key:"disposition_age"},
            { title: "Status", key: "warehouse_order_status" },
            { title: "IRRD Number", key: "irrd"},
            { title: "IRD Number", key:"ird"},
            { title: "Serial Number ", key: "serial_number" },
          ]);

          this.fetchDispatch();
        }
        if (tab == "Pending For Approval") {
          this.headers = [
                    { title: "Location", key: "location"},
                    { title: "IRD", key: "ird" },
                    { title: "Tag ID", key: "tag_number" },
                    { title: "Article ID", key: "article_id" },
                    { title: "Article Description", key: "article_description"},
                    { title: "Lot ID", key: "lot_id" },
                    { title: "Publish ID", key: "publish_id"},
                    { title: "Recovery Benchmark Price", key: "recovery_benchmark_price" },
                    { title: "Serial No.1", key: "serial_number" },
                    { title: "Serial No.2", key: "serial_number2"},
                    { title: "Approval Type", key: "approval_rule_type"},
                    { title: "Pending At", key: "next_approver_details"}
                ];
          this.select_field_items = [
             {
                "name":"Tag ID",
                "id": "tag_number"
              },
              {
                "name":"IRD",
                "id": "ird_number"
              },
              {
                "name":"Lot ID",
                "id": "lot_id"
              },
              {
                "name":"Publish ID",
                "id": "publish_id"
              },
              {
                "name":"Pending at",
                "id": "pending_at"
              }
        ]
          this.fetchPendingForApproval();
        }
      },
      fetchSupplierLoc() {
        this.$httpSecured
          .get("api/v2/supplier_locations")
          .then(response => {
            if (response.data.supplier_locations.length > 0) {
              this.locationListRel = response.data.supplier_locations.concat({
                id: 'more',
                name: 'More'
              });
              // this.loading = false;
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      // fetch the data from the API to load data to the table
      fetchPendingPriceAndLocation() {
        const params = {
          page: this.page,
          per_page: this.pageSize
        };
        if(this.search_tag){
          params[this.select_field.id] = this.search_tag.trim()
        }
        this.$httpSecured
          .post("api/v2/warehouse/markdown/pending_price_and_location", params)
          .then(response => {
            if (response.data) {
              this.table_data = response.data.markdowns || []
              this.totalPages = response.data.meta.total_pages
              this.totalCount = response.data.meta.total_count
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },

      // fetch the Pending ORRD data from the API to load data to the table
      fetchPendingOrrd() {
        const params = {
          page: this.page,
          per_page: this.pageSize,
          status: "pending_orrd"
        };
        if(this.search_tag){
          params[this.select_field.id] = this.search_tag.trim()
        }
        this.$httpSecured
          .post("api/v2/warehouse/markdown/pending_orrd", params)
          .then(response => {
            if (response.data) {
              this.table_data = response.data.markdowns || []
              this.totalPages = response.data.meta.total_pages
              this.totalCount = response.data.meta.total_count
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },

      // fetch the dispatch data from the API to load data to the table
      fetchDispatch() {
        const params = {
          page: this.page,
          per_page: this.pageSize
        };
        if(this.search_tag){
          params[this.select_field.id] = this.search_tag.trim()
        }
        this.$httpSecured
          .post("/api/v2/warehouse/markdown/dispatch", params)
          .then(response => {
            if (response.data) {
              this.table_data = response.data.warehouse_order_items || []
              this.totalPages = response.data.meta.total_pages
              this.totalCount = response.data.meta.total_count
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      fetchPendingForApproval() {
         const params = {
          page: this.page,
          per_page: this.pageSize,
          status: "pending_approval"
        };
        if(this.search_tag){
          params[this.select_field.id] = this.search_tag.trim()
        }
        this.$httpSecured
          .post("api/v2/warehouse/markdown/pending_price_and_location", params)
          .then(response => {
            if (response.data) {
              this.table_data = response.data.markdowns || []
              this.totalPages = response.data.meta.total_pages
              this.totalCount = response.data.meta.total_count
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      // fetch the category list in the filter drop-down
      fetchFilterCategory() {
        this.$httpSecured
          .get("/api/v2/warehouse/markdown/pending_price_and_location/filter_categories")
          .then(response => {
            if (response.data) {
              this.categoryList = response.data.categories
              this.categoryList.sort();
              // this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },

      // fetch the Location id in the update markdown 
      fetchLocationId() {
        this.$httpSecured
          .get("/api/v2/warehouse/markdown/pending_price_and_location/get_distribution_center")
          .then(response => {
            if (response.data) {
              this.locationList = response.data.distribution_centers
              // this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },

      // fetch the Grade list in the filter drop-down
      fetchFilterGrade() {
        this.$httpSecured
          .get("/api/v2/warehouse/markdown/pending_price_and_location/filter_grade")
          .then(response => {
            if (response.data) {
              this.gradeList = response.data.grade
              this.gradeList.sort();
              // this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },

      applyFilterFunc() {
        let filter;
        this.search_tag = '';
        this.isFilteringPage = true;
        if (this.minValue == null && this.maxValue == null) {
          filter = {
            "tag_id": this.tag_id_search,
            "grade": this.grade_filter,
            "category": this.category_filter,
          }
        } else if (this.minValue !== null && this.maxValue !== null) {
          if (this.maxValue < this.minValue) {
            this.showAlert("error", "Min value is greater than Max value");
          }
          const range = {
            "min": this.minValue,
            "max": this.maxValue
          }
          filter = {
            "tag_id": this.tag_id_search,
            "grade": this.grade_filter,
            "category": this.category_filter,
            "asp": range
          }
        } else if (this.minValue == null || this.maxValue == null) {
          this.showAlert("error", "You have to enter both max and min value");
        }

        const range = {
          "min": this.minValue,
          "max": this.maxValue
        }
        this.$httpSecured 
          .post('/api/v2/warehouse/markdown/pending_price_and_location', { "filter": filter, 'page': this.page, 'per_page': this.pageSize, "putaway":this.putaway_filter })
          .then(response => {
            if (response.data) {
              this.table_data = response.data.markdowns || []
              this.totalPages = response.data.meta.total_pages
              this.totalCount = response.data.meta.total_count
              this.filterPopup = false;
              this.tag_id_search = '';
              this.maxValue = null,
              this.minValue = null,
              this.grade_filter = [];
              this.category_filter = [];
              this.putaway_filter = null;
              this.loading = false;
              this.selected = [];
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      navigateToFileUpload() {
        this.$store.commit("setLotIds", {
          lotIds: this.headerText,
          inventoryId: "Pending Price & Location",
          action:'first_tab'
        });       
        this.$router.push({ name: "LotFileuploadComm" });
      },
      downloadDocument() {
        const params = {
          // status: 'Pending Price & Location',
          markdown: {
            ids:this.selected.map(x =>parseInt(x.id))
          }
        };
        this.$httpSecured
          .post("/api/v2/warehouse/markdown/pending_price_and_location/download_markdown", params)
          .then(response => {
            if (response.data) {
                const link = document.createElement("a");
                link.href = response.data.url;
                link.target = "_blank";
                link.download = "markdown.csv";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.okapproveconfirmpopup = true;
                this.message = this.active_tab + "(CSV File) Downloaded Successfully";
                this.selected = [];
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
              this.selected = [];
            }
          })
          .catch(error => {
            // this.showAlert("error", "Something went wrong from Network" + error);
            this.$toast.error(error.response.data.error);
          });
      },
      openPopup() {
        this.downloadDialog = true;
      },
      downloadSelected() {
        const type = this.selected.length === 0 ? 'submit' : 'selected';
        this.$refs.downloadPopup.downloadConfirmation(type);
      },
      getApiEndpoint() {
        if(this.isPendingPriceTab) {
          this.payload = {
            ids: this.selected.map(x => (x.id))         
          };
          return "/api/v2/warehouse/markdown/pending_price_and_location/download_markdown";
        } else if (this.active_tab === 'Dispatch') {
            this.payload = {
            ids: this.selected.map(x => (x.id)),
            is_download: true          
          };
          return "/api/v2/warehouse/markdown/dispatch";
        } else {
          this.payload = {
          ids: this.selected.map(x => (x.id)),
          is_download: true,
          status: 'pending_approval'          
        };
          return "/api/v2/warehouse/markdown/pending_price_and_location";
        }
      },
      handleShowAlert(alertData) {
        this.showAlert(alertData.type, alertData.message);
      },
      closeFilterpopup() {
        this.filterPopup = false;
        this.tag_id_search = '';
        this.grade_filter = [];
        this.category_filter = [];
        this.maxValue = null;
        this.minValue = null;
        this.putaway_filter = null;
      },

      // filter Dialog PopUP 
      filterListOfButtons(ev) {
        this.filterPopup = true;
      },

      // Update Dialog for Pending Price & Location Tab
      updatedialog() {
        if (this.selectedDirectly) {
          this.aspSum = (this.item_details.price == null) ? 0 : this.item_details.price;
        }
        else {
          let sum = 0;
          const prList = this.selected.map(markdowns => markdowns.price);
          for (let i = 0; i < prList.length; i++) {
            sum += Number(prList[i]);
          }
          this.aspSum = sum;
        }
        if(this.$isRelianceClient()){
          var dc = this.selected.map(x =>  x.supplier_code);
        const unique = (value, index, self) => {
              return self.indexOf(value) === index
            }
            dc = dc.filter(function( element ) {
              return element !== undefined;
            });
        var unique_array = dc.filter(unique)
        if (unique_array.length > 1) {
          this.location_id_rel = unique_array
              this.selected = []
              this.UpdatePopup = false;
              this.showAlert("error", "Select Same Supplier");
              return
            }
            const value = this.locationListRel.find(item => item.name === unique_array[0]);  
            if (value) {
              this.location_id_rel = value.id;
            }
        }
        this.UpdatePopup = true;
        this.number = 0;
      },

      updateSecondDialog() {
        this.number = 0;
        this.UpdatePopup = true;
        this.selectedDirectly = true;
        this.dataDetailPendingPricePopup = false;
        this.updatedialog();
      },
      updateSupplierApi() { 
        if(this.more_id === 'more'){
          this.$httpSecured.post("/api/v2/supplier_locations", {
          "supplier_code": this.enter_name
        },)
          .then(response => {
            if (response.data) {
            this.updatePendingConfirmationSubmit(response.data.id);
            } else {
            this.number = 0;
            this.$toast.error("No Data Found");
            }
          }).catch(error => {
            this.number = 0;
            this.$toast.error(error.response.data.error)
            this.loading = false;
          });
          }else{
            this.updatePendingConfirmationSubmit();
          }
      },
      // submit on update dialog in Pending-Confirmation
      updatePendingConfirmationSubmit(value) {
        let supplier_id;
        if(value){
          supplier_id = value;
        }else if(this.more_id !== 'more'){
          supplier_id = this.location_id_rel;
        }
        this.number++;
        let markdown;
        if (this.selectedDirectly) {
          this.update_id = this.item_details.id;
          markdown = {
            "ids": this.update_id,
            "markdown_location": this.$isRelianceClient() ? supplier_id : this.location_id,
            "markdown_price": this.aspSum - this.markdown_dis_value,
            "markdown_discount": this.markdown_discount,
          }
        } else {
          this.update_id = this.selected.map(markdowns => markdowns.id)
          markdown = {
            "ids": this.update_id,
            "markdown_location": this.$isRelianceClient() ? supplier_id : this.location_id,
            "markdown_price": this.aspSum - this.markdown_dis_value,
            "markdown_discount": this.markdown_discount,
          }
        }
        this.$httpSecured.post("/api/v2/warehouse/markdown/pending_price_and_location/update_markdowns", {
          "markdown": markdown
        })
          .then(response => {
            if (response.data) {
              this.message = response.data.message
              this.UpdatePopup = false;
              this.selectedDirectly = false;
              this.okapproveconfirmpopup = true;
              this.price = '';
              this.location_id = '';
              this.markdown_dis_value = '';
              this.markdown_discount = '';
              this.markdown_pr_dis = false;
              this.markdown_discount_dis = false;
              this.location_id_rel = '';
              this.more_id === '';
              this.showAlert("success", "Successfully updated");
            } else {
              this.number = 0;
              this.$toast.error('error", "No Data Found')
            }
          })
          .catch(error => {
            this.number = 0;
            this.$toast.error(error.response.data.error);
            // this.showAlert("error", error.response.data.error);
            this.loading = false;
          });
      },

      // clear all fields when clicked cancel in pending-confirmation
      updatePendingConfirmationCancel() {
        this.price = '';
        this.location_id = '';
        this.markdown_dis_value = '';
        this.markdown_discount = ''
        this.UpdatePopup = false;
        this.selectedDirectly = false;
        this.markdown_pr_dis = false,
          this.markdown_discount_dis = false
      },

      afterClickOkLoadData() {
        this.okapproveconfirmpopup = false;
        this.loadData(this.active_tab);
      },

      itemDetailpopup(item) {
        if (this.isPendingPriceTab) {
          this.dataDetailPendingPricePopup = true;
          this.tag_number = item.tag_id;
          let str = String(this.tag_number);
          this.tag_number = str;
          this.item_id = item.tag_id;
          this.item_details = item;
        }
        else if (this.active_tab == 'Dispatch') {
          this.tag_number = item.tag_id;
          let str = String(this.tag_number);
          this.tag_number = str;
          this.item_id = item.item_details;
          this.item_details = item;
          this.dataDetailDispatchPopup = true;
        }
      },
      handlePageChange(value) {
        this.page = value;
        if (this.isFilteringPage) {
          this.applyFilterFunc();
          return;
        }
        else if (this.active_tab === 'Pending Price & Location') {
          this.fetchPendingPriceAndLocation();
        } else if (this.active_tab === 'Pending ORRD') {
          this.fetchPendingOrrd();
        } else if(this.active_tab == 'Pending For Approval') {
          this.fetchPendingForApproval();
        }else {
          this.fetchDispatch();
        }
      },

      handlePageSizeChange(size) {
        this.pageSize = size;
        this.page = 1
        if (this.isFilteringPage) {
          this.applyFilterFunc();
          return;
        }
        else if (this.active_tab === 'Pending Price & Location') {
          this.fetchPendingPriceAndLocation();
        } else if (this.active_tab === 'Pending ORRD') {
          this.fetchPendingOrrd();
        } else if(this.active_tab == 'Pending For Approval') {
          this.fetchPendingForApproval();
        } else {
          this.fetchDispatch();
        }
      },

      reversepopup() {
        aspPopup = !aspPopup;
      },

      makeMarkdownDiscountDisable() {
        if (this.markdown_dis_value > this.aspSum) {
          this.updatePendingConfirmationCancel();
          this.showAlert("error", "Markdown Discount Value should be smaller than ASP");
        }
        else if (this.markdown_dis_value > 0) {
          this.markdown_discount_dis = true;
          const percent = (this.markdown_dis_value * 100 / this.aspSum);
          this.markdown_discount = percent.toFixed(2);
        } else if (this.markdown_dis_value == 0) {
          this.markdown_discount = '';
          this.markdown_discount_dis = false;
        }

      },
      makeMarkdownPriceDisable() {
        if (this.markdown_discount > 100) {
          this.updatePendingConfirmationCancel();
          this.showAlert("error", "Markdown Discount % should be smaller than 100");
        }
        else if (this.markdown_discount > 0) {
          this.markdown_pr_dis = true;
          this.markdown_dis_value = (this.markdown_discount * this.aspSum) / 100;
        } else if (this.markdown_discount == 0) {
          this.markdown_dis_value = '';
          this.markdown_pr_dis = false;
        }
      },
      cancelAspValues() {
        this.maxValue = '';
        this.minValue = '';
        this.aspValue = false;
      },
      inputRules2(v){
        v = v.replace(/,/g, '')
        return  v == '' || v >= 0 || /^\d+(\.\d+)?$/.test(v) || "Please enter only positive numbers";
      },
      changeLocation(valueitemData){
        if(valueitemData === 'more'){
          this.more_id = valueitemData
        }else{
          this.more_id = '';
          this.enter_name = '';
        }
      },
      handleSuccess(msg) {
        this.okapproveconfirmpopup = true;
        this.message = msg
      }
    }
  }
</script>
<style scoped>
  .v-dialog:has(.filter-data) {
    justify-content: right;
    align-items: baseline;
    top: 15rem;
  }

  .link-color {
    color: #0357D0;
    font-size: 14px;
    font-weight: 600;
  }

  .bg-color {
    background: #0357D0;
    color: #ffffff;
  }

  .min_maax_container {
    display: flex;
    align-items: center;
  }

  .mn_mx_box {
    max-width: 400px;
    width: 100%;
  }

  .v-autocomplete__content.v-menu__content .v-select-list {
    max-width: 285px !important;
  }
  .item-selected {
    margin-top: 29px;
    position: absolute;
    left: 35%;
  }
  @media (max-height: 1104px) {
    .PaddingItemPerPage{
      padding: 8px !important;
    }
  }
  @media (min-height: 1126px) {
    .PaddingItemPerPage{
      padding: 24px !important;
    }
  }

  .v-data-table {
    height: calc(var(--vh, 1vh) * 100 - 320px) !important;
  }
  .update_disabled{
      pointer-events: none; 
      opacity: 0.5;
      color: gray;
    }
    .filter_ui{
    margin-left: 25px !important;
    margin-top: -15px !important;
 }
 .custom-control_outlined .v-expansion-panel:before {
  box-shadow: none;
}

.custom-control_outlined button {
  min-height: 52px;
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.42);
  border-style: solid;
}

.custom-control_outlined button:focus {
  outline: none;
}
</style>
    
